










































































































































































import { Component, Vue } from "vue-property-decorator";
import {dispatchDeleteCompany, dispatchGetCompanies} from "@/store/main/actions";
import { readHasAdminAccess, readCompanies, readUserProfile } from "@/store/main/getters";
import { Company, Currency, Miner } from "@/interfaces";
import { readCurrencies } from "@/store/wallet/getters";
import { dispatchGetCurrencies } from "@/store/wallet/actions";

@Component
export default class Companies extends Vue {
  public headers = [
    {
      text: "نام ",
      sortable: true,
      value: "name",
      align: "right"
    },
    {
      text: "تعداد قرارداد",
      sortable: true,
      value: "contracts",
      align: "right"
    },
    {
      text: "تعداد ماینر",
      sortable: true,
      value: "miners",
      align: "right"
    },{
      text: "وضعیت",
      sortable: true,
      value: "active",
      align: "right"
    },
    // ,{
    //   text: "نمایش",
    //   sortable: true,
    //   value: "view",
    //   align: "right"
    // }
    {
      text: "حذف",
      sortable: false,
      value: "delete",
      align: "right"
    }
    ,{
      text: 'نمایش',
      value: 'data-table-expand',
      align: "right"

    },
  ];

  public fetched = false;
  public dialog = false;
  public selectedCompany:Company | null = null;
  public expanded =  []

  get isAdmin() {
    return readHasAdminAccess(this.$store);
  }
  get companies() {
    return readCompanies(this.$store);
  }

  public showCompany(value){
    this.$router.push({name: 'main-company-view', params: { id: value.id },})
  }

  public getHashrate(hashrate: number, currency_id: number) {
    let unit = "MH";
    let fix_number = 2;
    let power_number = 6;
    if(this.getCurrencyName(currency_id) == "XCC" ||  this.getCurrencyName(currency_id) == "XCH"){
      unit = "TB";
      fix_number = 5;
      power_number = 12;
    }
    return (hashrate / 10 ** power_number).toFixed(fix_number) +unit;
  }

  public getCurrencyName(currency_id: number) {
    return readCurrencies(this.$store).find(
      (currency: Currency) => currency.id === currency_id
    )!.name;
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public hashText(currency_id){
    const currency = this.getCurrencyName(currency_id)
    if (currency == "XCC" || currency == "XCC")
      return "حجم"
    else
      return "نرخ هش"
  }

  public async mounted() {

    if (this.isAdmin) {
      this.headers.splice(0, 0, {
        text: "ID",
        sortable: true,
        value: "id",
        align: "right"
      });

    }

    const own = !this.isAdmin // if user is admin, set own to false
    await Promise.allSettled([
      dispatchGetCurrencies(this.$store),
      dispatchGetCompanies(this.$store,own),
  ]);

    this.setRotate()

    this.fetched = true;
  }

  public showRemoveModal(company){
    this.selectedCompany = company;
    this.dialog = true;
  }

  public async remove(){
    this.dialog = false;
    this.fetched = false;

    const id = this.selectedCompany?.id ?? -1;
    const own = !this.isAdmin; // if user is admin, set own to false


    await Promise.allSettled([
      dispatchDeleteCompany(this.$store,{own: own, id: id}),
    ]);

    this.setRotate();

    this.fetched = true;
  }

  public async  setRotate(){
    this.companies.map(company=>{
      let deg = 270;
      company['rotates'] = []
      company?.contracts.map(contract =>{
        company['rotates'].push(deg)
        deg = deg + (contract.share * 3.6);

      })
    })
  }

  public activeMinersCount(miners: Miner[]){
    let count = 0;
    miners.map(item=>{
      if(item.is_active)
        count ++;
    })
    return count;
  }

  public getColor(index){
    const mod = index % 10;
    switch (mod) {
      case 0:
        return "#F44336";
      case 1:
        return "#E91E63";
      case 2:
        return "#2196F3";
      case 3:
        return "#FF9800";
      case 4:
        return "#9C27B0";
      case 5:
        return "#4CAF50";
      case 6:
        return "#3F51B5";
      case 7:
        return "#607D8B";
      case 8:
        return "#009688";
      case 9:
        return "#673AB7";

    }
  }

}
